export default function AVERAGEIFS() {
  return <div>Excel_AVERAGEIFS</div>;
}
